import { useContext } from 'react';
import { TriggerFormContext } from './TriggerFormContext.jsx';

export const useTriggerForm = () => {
    const context = useContext(TriggerFormContext);
    if (!context) {
        throw new Error(
            'useTriggerForm must be used within a TriggerFormProvider',
        );
    }
    return context;
};
